import React from 'react';

import bg from 'shared/img/bg.svg';

const bgAnimation = `
  @keyframes bgZoomIn {
    0% { transform: scale(0.3); opacity: 0; top: calc(2vh - 200px); }
    100% { transform: scale(1); opacity: 0.25; top: calc(2vh - 50px); }
  }
`;

export const Background = () => {

  return (
    <>
      <style>{bgAnimation}</style>
      <div
        id="cvt-bg"
        style={{
          position: 'fixed',
          left: '-5vw',
          top: 'calc(2vh - 50px)',
          width: '110vw',
          height: '110vh',
          zIndex: 1,
          opacity: 0,
          backgroundImage: `url(${bg})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          animation: 'bgZoomIn 3s ease-out forwards',
        }}
      />
    </>
  );
};
